
import { Component, Vue, Prop } from "vue-property-decorator";

@Component({
  components: {}
})
export default class About extends Vue {
  async mounted() {}

  get title() {
    return "About";
  }
}
